export const patchData2024 = [
  {
    id: "mar-24",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Maret - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Data Survey, Project Management, Store Master dan Report.",
    changelog: [
      "Data Survey: Penambahan fitur export rawdata.",
      "Non Projected Reporting: Penambahan perhitungan di laporan.",
      "PBI Data: Pembuatan akses data eksternal.",
    ],
    datas: [
      {
        id: 1,
        title: "Data Survey",
        date: "27 Maret 2024",
        items: ["Pembuatan sistem antrian dan tombol process serta download"],
      },
      {
        id: 2,
        title: "Non Projected Reporting",
        date: "27 Maret 2024",
        items: [
          "Penambahan kolom Provinsi dan Kab/Kota pada Detail survey RAK2",
        ],
      },
      {
        id: 3,
        title: "Project Management",
        date: "27 Maret 2024",
        items: ["Validasi create project terkait prev_period"],
      },
      {
        id: 4,
        title: "Store Master",
        date: "27 Maret 2024",
        items: [
          "Implementasi efisiensi pemanggilan data dan state management",
          "Validasi pengecekan jenis outlet, tipe survey, tipe jalan, tipe lokasi saat import store",
        ],
      },
      {
        id: 5,
        title: "Projected Reporting",
        date: "27 Maret 2024",
        items: [
          "Halaman baru untuk menampilkan data pivot terkait table rpt",
          "Halaman baru untuk menampilkan data mentah tabular terkait table rpt",
        ],
      },
    ],
  },
  {
    id: "apr-24",
    type: ["Backend"],
    color: ["#ff8a65"],
    title: "April - Notes",
    year: "2024",
    description: "Perubahan pada Report Non Projected dan Data Export.",
    changelog: [
      "Pembuatan sistem baru di Report Non Projected dan perbaikan Data Export.",
    ],
    datas: [
      {
        id: 1,
        title: "Report Non Projected",
        date: "26 April 2024",
        items: ["Pembuatan sistem antrian"],
      },
      {
        id: 2,
        title: "Data Export",
        date: "26 April 2024",
        items: ["Perbaikan untuk mengeluarkan data status display"],
      },
    ],
  },
  {
    id: "jun-24",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Juni - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Product Master, Store Master, dan User Management.",
    changelog: [
      "Product Master: Penambahan fitur import setup.",
      "Store Master: Penambahan fitur import setup.",
      "User Management: Penambahan fitur import user.",
      "Report: Penyesuaian dan perbaikan report data.",
    ],
    datas: [
      {
        id: 1,
        title: "Product Master",
        date: "03 Juni 2024",
        items: ["Import setup product master"],
      },
      {
        id: 2,
        title: "Store Master",
        date: "03 Juni 2024",
        items: ["Import setup store master"],
      },
      {
        id: 3,
        title: "User Management",
        date: "03 Juni 2024",
        items: ["Import user management"],
      },
      {
        id: 4,
        title: "Report",
        date: "03 Juni 2024",
        items: [
          "Report RDC Pharmacy Non Projected di distribusi",
          "Report RDC Pharmacy Non Projected Storetype di distribusi",
          "Perbaikan export rawdata tipe project adhoc",
          "Perbaikan pengambilan data pada display report",
          "Perbaikan pengambilan data export ERRI untuk RDC",
        ],
      },
    ],
  },
  {
    id: "jul-24",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "Juli - Notes",
    year: "2024",
    description:
      "Perubahan dan penyesuaian pada halaman Data Processing, Product Master, Store Master, dan Reporting Non Projected.",
    changelog: [
      "Data Processing: Penambahan validasi dan multi-step pada proses data.",
      "Product Master: Validasi dan pengaturan attribute pada beberapa data.",
      "Store Master: Perbaikan export dan filter.",
      "Reporting Non Projected: Penyesuaian akses berdasarkan role.",
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing",
        date: "31 Juli 2024",
        items: [
          "Merubah proses data processing menjadi beberapa step",
          "Penyesuaian tampilan edit rawdata dengan format koma, titik, penggabungan kolom stok",
          "Perubahan pengambilan data packtype, packsize, flavor untuk edit product berdasarkan category yang dipilih di completeness",
          "Validasi pengecekan data pada tahap completeness check",
          "Upyear data product consistency berdasarkan product master attribute",
          "Penambahan deskripsi kota kabupaten pada table rawdata",
          "Validasi fungsi untuk melakukan pengecekan di setiap step",
          "Perubahan tampilan harga jual diubah menjadi harga final",
          "Perbaikan tampilan notifikasi untuk setiap step",
          "Validasi data untuk upyear category dan nama produk dari product master",
        ],
      },
      {
        id: 2,
        title: "Product Master",
        date: "30 Juli 2024",
        items: [
          "Perubahan pengambilan data packtype, packsize, flavor untuk edit dan create",
          "Validasi packtype, packsize, flavor pada import product master",
          "Menghapus pilihan packtype, packsize, flavor",
          "Setup edit packtype, packsize, flavor ada di pilihan category saat memilih salah satu category",
          "Merubah beberapa input menjadi product_master_attribute pada excel import product master setup",
          "Perbaikan validasi pada setup delete product master attribute",
          "Create setup product master attribute apabila terdapat data NA tidak bisa membuat",
        ],
      },
      {
        id: 3,
        title: "Store Master",
        date: "30 Juli 2024",
        items: [
          "Perbaikan filter tipe survey di export",
          "Perbaikan export setup template",
        ],
      },
      {
        id: 4,
        title: "Reporting Non Projected",
        date: "30 Juli 2024",
        items: ["Penyesuaian akses berdasarkan role"],
      },
    ],
  },
  {
    id: "agu-24",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "Agustus - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Product Master, Reporting Non Projected, Audit Plan, Data Processing, Data Survey, Project Management, dan konfigurasi sistem lainnya.",
    changelog: [
      "Product Master: Perbaikan input dan pemilihan data.",
      "Reporting Non Projected: Perbaikan perhitungan dan preview report.",
      "Audit Plan: Validasi status dan filter.",
      "Data Processing: Penambahan tombol export dan notifikasi.",
      "Data Survey: Perbaikan export dan filter lebih dari satu.",
      "Project Management: Validasi input simbol pada nama project.",
      "Other: Perbaikan input data dan konfigurasi export rawdata.",
    ],
    datas: [
      {
        id: 1,
        title: "Product Master",
        date: "06 Agustus 2024",
        items: [
          "Perbaikan input Packtype, Packsize dan Flavour untuk create dan edit product",
          "Data Packtype, Packsize, Flavour hanya akan muncul saat category sudah dipilih",
          "Pilihan Packtype, Packsize, Flavour, Category, Principal, Brand bisa dipilih dari pencarian",
        ],
      },
      {
        id: 2,
        title: "Reporting Non Projected",
        date: "09 Agustus 2024",
        items: [
          "Perbaikan perhitungan data di Marketshare Non Projected",
          "Menyesuaikan pengambilan semua data",
          "Menambahkan fitur untuk preview report",
        ],
      },
      {
        id: 3,
        title: "Audit Plan",
        date: "06 Agustus 2024",
        items: [
          "Perbaikan filter audit plan pada pilihan survey type",
          "Tidak diijinkan menghapus data dengan status closed",
          "Penyesuaian validasi upyear status pada data terpilih",
        ],
      },
      {
        id: 4,
        title: "Data Processing",
        date: "06 Agustus 2024",
        items: [
          "Perbaikan kalimat di notifikasi data preparation",
          "Tampilan Data Preparation saat consistency check ada tombol export untuk product maupun store",
          "Data Preparation untuk RDC MT dan Processing RDC MT",
        ],
      },
      {
        id: 5,
        title: "Data Survey",
        date: "09 Agustus 2024",
        items: [
          "Perbaikan export process dan download untuk filter tipe survey",
          "Filter status bisa lebih dari satu",
        ],
      },
      {
        id: 6,
        title: "Project Management",
        date: "19 Agustus 2024",
        items: [
          "Validasi create project untuk Project Name tidak diijinkan memasukan simbol tertentu",
        ],
      },
      {
        id: 7,
        title: "Other",
        date: "",
        items: [
          "Perbaikan custom question untuk mandatory",
          "Konfigurasi sistem untuk export rawdata",
        ],
      },
    ],
  },
  {
    id: "sep-24",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "September - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Product Master, Setup Product Master, Data Processing, Non Projected Reporting, Projected Reporting, Project Custom Question, dan Dashboard.",
    changelog: [
      "Product Master: Penyempurnaan validasi data dan penyesuaian input dan kolom.",
      "Setup Product Master: Penambahan menu baru, dan import/export terkait.",
      "Data Processing: Validasi nilai, penyesuaian tampilan, dan migrasi completeness check ke halaman.",
      "Non Projected Reporting: Pengelompokan report dan penyesuaian penamaan.",
      "Projected Reporting: Halaman tabular/pivot baru, penyesuaian data dan tampilan, serta export.",
      "Project Custom Question: Export data.",
      "Dashboard: Perbaikan filter.",
    ],
    datas: [
      {
        id: 1,
        title: "Product Master",
        date: "02 September 2024",
        items: [
          "Validasi perhitungan data di create, edit, import",
          "Menghapus opsi input unitvol di create dan edit product",
          "Data unitvol menyesuaikan category pada create/edit/import",
          "Create & edit product ada pengecekan Brand Category Master",
          "Export Product Master menghapus kolom unitvol",
        ],
      },
      {
        id: 2,
        title: "Setup Product Master",
        date: "20 September 2024",
        items: [
          "Tambahan menu category untuk unitvolume dan pengaturan create/edit",
          "Validasi upyear data pada category",
          "Menu baru: Brand Category Master",
          "Export & Import Product Master Setup untuk Brand Category Master",
          "Export & Import Product Master Setup menambah unitvolume di category",
        ],
      },
      {
        id: 3,
        title: "Data Processing",
        date: "02 September 2024",
        items: [
          "Validasi perhitungan data",
          "Perbaikan dan penyesuaian tampilan terpilih",
          "Completeness Check diubah dari modal ke halaman baru",
        ],
      },
      {
        id: 4,
        title: "Non Projected Reporting",
        date: "11 September 2024",
        items: [
          "Perubahan nama menjadi Non Projected Reporting",
          "Pengelompokan report berdasarkan tipe project",
        ],
      },
      {
        id: 5,
        title: "Projected Reporting",
        date: "11 September 2024",
        items: [
          "Halaman tabular & pivot report baru",
          "Perubahan penamaan dan penyesuaian nilai default",
          "Fitur export data report",
          "Penataan ulang kolom dan pengaturan akses serta format desimal",
        ],
      },
      {
        id: 6,
        title: "Project Custom Question",
        date: "20 September 2024",
        items: ["Export data custom question SKU"],
      },
      {
        id: 7,
        title: "Dashboard",
        date: "29 September 2024",
        items: ["Perbaikan filter pada pilihan kecamatan"],
      },
    ],
  },
  {
    id: "oct-24",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Oktober - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Data Processing, Project Management, Audit Plan, Product Master, dan Dashboard.",
    changelog: [
      "Data Processing: Pengurangan pilihan data.",
      "Project Management: Penambahan project dan penyempurnaan fitur.",
      "Audit Plan: Penyesuaian data yang ditampilkan.",
      "Product Master: Validasi import data.",
      "Dashboard: Refactor pengambilan data.",
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing",
        date: "25 Oktober 2024",
        items: ["Mengurangi pilihan DB Set"],
      },
      {
        id: 2,
        title: "Project Management",
        date: "15 Oktober 2024",
        items: [
          "Membuat project RAK2 B",
          "Tipe Project ADHOC bisa menghapus semua question kecuali foto product",
          "Penyesuaian tampilan tipe question",
        ],
      },
      {
        id: 3,
        title: "Audit Plan",
        date: "22 Oktober 2024",
        items: [
          "Create audit plan hanya menampilkan data yang berstatus active dan rentang end_at belum selesai",
        ],
      },
      {
        id: 4,
        title: "Product Master",
        date: "09 Oktober 2024",
        items: ["Validasi import pada kolom ctrl_price dan convertedvol"],
      },
      {
        id: 5,
        title: "Dashboard",
        date: "03 Oktober 2024",
        items: [
          "Refactor dan pembuatan ulang pengambilan data Summary Table, Stat, dan Daily Trend",
        ],
      },
    ],
  },
  {
    id: "nov-24",
    type: ["Interface", "Backend", "Other"],
    color: ["#4db6ac", "#ff8a65", "#979697"],
    title: "November - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Product Master, Store Master, Audit Plan, Project Management, Dashboard, User Management, Login, Logout, Reporting, Navbar, dan lainnya.",
    changelog: [
      "Product Master: Efisiensi pemanggilan data dan tampilan.",
      "Store Master: Efisiensi pemanggilan data dan tampilan.",
      "Audit Plan: Pembuatan halaman Import Audit Plan, Akses, dan License.",
      "Project Management: Validasi input dan implementasi license.",
      "Dashboard & User Management: Efisiensi pemanggilan data.",
      "Login & Logout: Implementasi dan perbaikan redirect.",
      "Reporting & Navbar: Perubahan nama.",
      "Other: Pembuatan sistem Import Audit Plan.",
    ],
    datas: [
      {
        id: 1,
        title: "Product Master",
        date: "04 November 2024",
        items: [
          "Implementasi pemanggilan data yang lebih efisien",
          "Pemecahan Modal Add Product dan Upload Product",
          "Penyesuaian Penamaan Button",
        ],
      },
      {
        id: 2,
        title: "Store Master",
        date: "04 November 2024",
        items: [
          "Penyesuaian penamaan button",
          "Implementasi pemanggilan data yang lebih efisien",
        ],
      },
      {
        id: 3,
        title: "Audit Plan",
        date: "04 November 2024",
        items: [
          "Implementasi pemanggilan data yang lebih efisien",
          "Penyesuaian penamaan button",
          "Pembuatan import untuk Audit Plan",
          "Penambahan table History Upload Audit",
          "Filter Status bisa lebih dari satu",
          "Countdown refresh untuk history import audit plan",
          "Penyesuaian akses untuk setiap role di import audit plan",
          "Implementasi license",
        ],
      },
      {
        id: 4,
        title: "Project Management",
        date: "04 November 2024",
        items: [
          "Penyesuaian penamaan button",
          "Penyesuaian notifikasi gagal edit data",
          "Edit Project input End At tidak lebih besar dari Start At",
          "Implementasi license",
        ],
      },
      {
        id: 5,
        title: "Dashboard",
        date: "17 November 2024",
        items: ["Efisiensi pemanggilan data filter dan data dashboard"],
      },
      {
        id: 6,
        title: "User Management",
        date: "17 November 2024",
        items: ["Efisiensi pemanggilan data filter dan data user management"],
      },
      {
        id: 7,
        title: "Login",
        date: "23 November 2024",
        items: ["Penyesuaian sistem login"],
      },
      {
        id: 8,
        title: "Logout",
        date: "04 November 2024",
        items: ["Perbaikan url redirect"],
      },
      {
        id: 9,
        title: "Projected Reporting",
        date: "04 November 2024",
        items: ["Perubahan nama Reported menjadi Reporting"],
      },
      {
        id: 10,
        title: "Non Projected Reporting",
        date: "04 November 2024",
        items: ["Perubahan nama Reported menjadi Reporting"],
      },
      {
        id: 11,
        title: "Navbar",
        date: "04 November 2024",
        items: ["Perubahan nama Reported menjadi Reporting"],
      },
      {
        id: 12,
        title: "Other",
        date: "",
        items: ["Pembuatan sistem untuk Import Audit Plan"],
      },
    ],
  },
  {
    id: "des-24",
    type: ["Interface", "Backend"],
    color: ["#4db6ac", "#ff8a65"],
    title: "Desember - Notes",
    year: "2024",
    description:
      "Perubahan pada halaman Data Processing, Non Projected Reporting, Projected Reporting, License, Audit Plan, Dashboard, Data Survey, dan lainnya.",
    changelog: [
      "Data Processing: Penambahan fitur dan logika baru pada konsistensi dan transfer data.",
      "Non Projected Reporting: Penyesuaian perhitungan dan logika.",
      "Projected Reporting: Penyesuaian filter export data.",
      "License: Sistem pembaharuan lisensi.",
      "Audit Plan, Dashboard, Data Survey: Penyesuaian format penamaan data.",
    ],
    datas: [
      {
        id: 1,
        title: "Data Processing",
        date: "03 Desember 2024",
        items: [
          "Penambahan fungsi dan pesan Sync Raw Data",
          "Transfer Data dan Insert Raw penyesuaian input data",
          "Consistency Check mengecualikan perbedaan spasi, huruf besar/kecil pada nama outlet dan produk",
          "Menambah remarks jika product dan store tidak lengkap",
          "Memperbaiki data yang ditampilkan pada tombol go to Product/Store diklik",
        ],
      },
      {
        id: 2,
        title: "Non Projected Reporting",
        date: "10 Desember 2024",
        items: [
          "Penambahan fungsi dan pesan Sync Raw Data",
          "Transfer Data dan Insert Raw penyesuaian input data",
          "Menambah perhitungan kolom AVG_HARGA di Report Price by Area dan Tipe Lokasi",
          "Perhitungan harga di Project RDC GT dan MT",
          "Penghapusan Distribution di level Group, Brand, Average",
          "Pendefinisian pada Distribution",
          "Pengambilan data untuk Group, Brand, Toko, dan Produk",
        ],
      },
      {
        id: 3,
        title: "Projected Reporting",
        date: "11 Desember 2024",
        items: [
          "Download data bisa menerima filter Fact lebih dari satu pilihan",
        ],
      },
      {
        id: 4,
        title: "License",
        date: "23 Desember 2024",
        items: ["Sistem pembaharuan Lisensi"],
      },
      {
        id: 5,
        title: "Audit Plan",
        date: "03 Desember 2024",
        items: ["Penyesuaian pilihan Full Name Surveyor"],
      },
      {
        id: 6,
        title: "Dashboard",
        date: "03 Desember 2024",
        items: ["Penyesuaian pilihan Full Name Surveyor"],
      },
      {
        id: 7,
        title: "Data Survey",
        date: "03 Desember 2024",
        items: ["Penyesuaian pilihan Full Name Surveyor"],
      },
    ],
  },
]
